import React from "react";

const IWarning = ({
  color = "#FD4949",
  width = "16",
  height = "16",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.1667 8C13.1667 5.14653 10.8535 2.83333 8 2.83333C5.14653 2.83333 2.83333 5.14653 2.83333 8C2.83333 10.8535 5.14653 13.1667 8 13.1667C10.8535 13.1667 13.1667 10.8535 13.1667 8ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z"
        fill={color}
      />
      <path
        d="M12.8047 11.862L11.862 12.8047L3.19531 4.13802L4.13802 3.19531L12.8047 11.862Z"
        fill={color}
      />
    </svg>
  );
};

export default IWarning;
